import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  settingsData: any;
  settingsLoading: boolean;
  settingsError: SerializedError | null;
} = {
  settingsData: null,
  settingsLoading: false,
  settingsError: null,
};

export const settingsFunc = createAsyncThunk('settings/settingsFunc', async () => {
  const data1 = JSON.stringify({
    query: `query Settings {
      settings {
        dashboardComponents {
          _id
          categories {
            _id
            defaultSorting
            description
            imageUrl
          }
          name
          nameVisible
          updatedAt
          createdAt
          componentType
        }
      }
    }`,
  });

  const config = initialConfig(process.env.REACT_APP_BASE_URL_ACTIVITY || '', data1, '');

  const response = axios(config)
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => err);

  const data = await response;
  return data;
});

const settings = createSlice({
  name: 'settings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(settingsFunc.pending, (state) => {
      state.settingsLoading = true;
    });
    builder.addCase(settingsFunc.fulfilled, (state, action) => {
      state.settingsLoading = false;
      state.settingsData = action.payload.data.settings?.dashboardComponents;
      state.settingsError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(settingsFunc.rejected, (state, action) => {
      state.settingsLoading = false;
      state.settingsError = action.error ?? null;
    });
  },
});

export default settings.reducer;
